import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { UserService } from "src/app/auth/user.service";
import { BuildingSurveyViewModel } from "src/app/shared/Models/buildingTableViewModel";
import { SurveyStatus } from "src/app/shared/Models/enums/SurveySurveyStatus";
import {
  DialogService,
  DialogType,
} from "src/app/shared/services/dialog.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { User } from "../../../../auth/models/user";
import { BuildingService } from "../../services/building.service";

@Component({
  selector: "app-reassign-survey-to-surveyor",
  templateUrl: "./reassign-survey-to-surveyor.component.html",
  styleUrls: ["./reassign-survey-to-surveyor.component.scss"],
})
export class ReassignSurveyToSurveyorComponent implements OnInit {
  @Input() buildingSurveyVm: BuildingSurveyViewModel;
  @Input() buildingSurveyVms: BuildingSurveyViewModel[];
  @Output() closeReassign: Subject<BuildingSurveyViewModel[]> = new Subject<
    BuildingSurveyViewModel[]
  >();
  @Output() reloadBuildingList: EventEmitter<any> = new EventEmitter<any>();

  users: User[];
  userForm: FormGroup;
  searchText: string;

  constructor(
    private _fb: FormBuilder,
    private _buildingService: BuildingService,
    private dialogService: DialogService,
    private loaderService: LoaderService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.getAllUsers().subscribe((res) => {
      this.users = res;
      this.buildUserOverView();
    });
  }

  onClose() {
    this.closeReassign.next(this.buildingSurveyVms);
  }

  assignSurveyToSurveyor(user: User) {
    this.dialogService
      .openDialog({
        headerText: $localize`:@@buildinglist.assignsurveytosurveyor.header:reassign survey to surveyor`,
        detailText: $localize`:@@buildinglist.assignsurveytosurveyor.detailtext:This action will reassign survey to surveyor, are you sure?`,
        dialogType: DialogType.Continue,
        fullscreen: true,
      })
      .pipe(first())
      .subscribe((feedback) => {
        if (!feedback) return;

        this.loaderService.show();
        if (
          (this.buildingSurveyVm.surveyStatus as number) >= 4 &&
          this.buildingSurveyVm.surveyStatus != SurveyStatus.Prefill
        )
          this.reassignInsideSurvey(user);
        else this.reassignOutsideSurvey(user);
      });
  }

  reassignOutsideSurvey(user: User) {
    this._buildingService
      .reassignOutsideEngineer(user.userId, this.buildingSurveyVm.surveyId)
      .pipe(first())
      .subscribe(
        (res) => {
          this.reloadBuildingList.emit();
          this.loaderService.hide();
          this.closeReassign.next(this.buildingSurveyVms);
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  reassignInsideSurvey(user: User) {
    this._buildingService
      .reassignInsideEngineer(user.userId, this.buildingSurveyVm.insideSurveyId)
      .pipe(first())
      .subscribe(
        (res) => {
          this.loaderService.hide();
          this.closeReassign.next(this.buildingSurveyVms);
        },
        () => {
          this.loaderService.hide();
        }
      );
  }

  buildUserOverView() {
    this.userForm = new FormGroup({
      UsersGroupOverview: this._fb.array(this.users),
    });
  }
}
